import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";
import { getCategoryBySlug } from "@/mocks/comics";

interface ComicCardProps {
  comic: Comic;
  showCategory?: boolean;
}

export default function ComicCard({ comic, showCategory = true }: ComicCardProps) {
  const category = getCategoryBySlug(comic.category);
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-100 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden">
        <img
          src={comic.cover}
          alt={comic.coverAlt}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-full bg-foreground-950/70 px-2.5 py-0.5 text-xs font-medium text-background-50 backdrop-blur-sm">
          {comic.status}
        </span>
        <span className="absolute right-2 top-2 inline-flex h-8 w-8 items-center justify-center rounded-full bg-primary-500 text-sm font-bold text-background-50">
          {comic.rating}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-1.5 p-3 md:p-4">
        {showCategory && category && (
          <span className="flex items-center gap-1 text-xs font-medium text-primary-600">
            <i className={`${category.icon} text-xs`} />
            {category.name}
          </span>
        )}
        <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700 md:text-lg">
          {comic.title}
        </h3>
        <p className="line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
          {comic.synopsis}
        </p>
        <div className="mt-auto flex flex-wrap items-center gap-1.5 pt-2">
          {comic.genres.slice(0, 3).map((g) => (
            <span
              key={g}
              className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800"
            >
              {g}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}